<template>
  <div>
    {{ name }}
  </div>
</template>

<script>

export default {
  props: ['data', 'index', 'column'],
  computed: {
    name () {
      if (this.data.category) {
        return this.translation(this.data.category).name
      }
    }
  }
}
</script>
